"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// components
const OrderStatus = ({
  side,
  amount,
  qty,
  conditionType
}) => (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "flex-end"
}, conditionType !== null ? (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.Text, {
  variant: "metaBold",
  color: "text.1"
}, conditionType), (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: side === 'Buy' ? 'text.positive' : 'text.negative'
}, qty ? "".concat(amount, "/").concat(qty, " Qty") : '', "\xA0\xA0", "".concat(side))) : (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.LoadingBlock, {
  width: 48,
  height: 11
}), (0, _pragma.createFelaElement)(_.LoadingBlock, {
  width: 64,
  height: 11
})));

var _default = OrderStatus;
exports.default = _default;
//# sourceMappingURL=OrderStatus.js.map